type EnvConfig = {
  adultAges: Config['adultAges'];
  checkAllowedCountries: Config['checkAllowedCountries'];
  allowedCountries: Config['allowedCountries'];
  api: {
    apiUrl: string;
    clmApiUrl: string;
    accountApiUrl: string;
  };
  environment: 'local' | 'adc_clm_preprod_us' | 'adc_clm_stage_us';
  logLevel: string;
  mock: boolean;
  mode: 'local' | 'staging' | 'pre-production' | 'production';
};

export const _config = {} as EnvConfig;

export const getEnvConfig = async () => {
  const response = await fetch('/config.json', {
    method: 'GET',
    headers: {
      'Content-type': 'application/json',
    },
  });

  if (response.ok) {
    const data = (await response.json()) as EnvConfig;

    Object.assign(_config, data);

    return data;
  }

  throw new Error('Failed to load environment configuration');
};
